import { performSearch, BASE_SHARE_CLASS_FILTER_REQUEST } from "./";
import { isNullOrUndefined, orchestrateBasicSearchResponse, safe } from "../utils";
import { IDataEntityResponse, ISorting, IAppParams, ISearchEntityRequest } from "../models";

export async function fetchShareClasses(options: ISearchEntityRequest, appParams: IAppParams, isSearchPrimerCall: any = false, sorting: ISorting = { sortOrder: 'ASC' }): Promise<IDataEntityResponse> {
    let response = <IDataEntityResponse>{};
    let searchElements = [...options.search.filter(i => BASE_SHARE_CLASS_FILTER_REQUEST.filterProperties.indexOf(i.property) > -1)];

        Object.assign(options, {
            type: "CLSS",
            search: searchElements,
            sort: {
                key: "infinite_sort",
                direction: sorting.sortOrder
            }
        });

            Object.assign(options, {
                include: {
                    "timeseries": {
						"limitTo": ["distribution_rates"]
					},
                }
            });

        let searchResponse = await performSearch(options, appParams);
        if (searchResponse.error) {
            response.error = searchResponse.error;
        }
        else {
            response = orchestrateBasicSearchResponse(searchResponse.data);
        }

    return response;
}



// WEBPACK FOOTER //
// ./src/client/data/shareClass.ts